// extracted by mini-css-extract-plugin
module.exports = {"inactive":"_base-button-play_inactive_18diM"};